<template>
    <div class="help">
        <h1>This is an Help page</h1>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {}
    },
    computed: {}
}
</script>